<template>
  <div class="w-chart">
    <div class="w-toolbar">
      <div class="w-chips">
        <span v-for="m in milestones" :key="m.year" class="chip" :class="{ accent: m.year === 2050 }"><b>{{ compact(m.stock) }} t</b> by {{ m.year }}</span>
      </div>
    </div>
    <div class="w-plot">
      <apexchart :key="chartKey" v-if="years.length" type="line" height="100%" :options="options" :series="series"/>
      <div v-else class="w-empty">
        <i class="fas fa-rocket"></i>
        <span>{{ stats.insights ? 'The forecast appears once the forests have their theoretical growth calculated.' : 'Loading…' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { apexBase, compact, fmt, palette, themeState } from '../theme';

export default {
  name: 'Forecast',
  components: { apexchart: VueApexCharts },
  props: { stats: { type: Object, required: true } },
  computed: {
    // a theme or data change re-creates the chart: ApexCharts does not always redraw mixed charts on update
    chartKey() { return `${themeState.tick}:${JSON.stringify(this.series)}`; },
    forecast() { return (this.stats.insights && this.stats.insights.forecast) || { years: [], currentYear: new Date().getFullYear() }; },
    years() { return this.forecast.years || []; },
    milestones() {
      return [2030, 2040, 2050].map((y) => this.years.find((r) => r.year === y)).filter(Boolean);
    },
    series() {
      return [
        { name: 'CO2 held by the forests (t)', type: 'area', data: this.years.map((r) => ({ x: r.year, y: r.stock })) },
        { name: 'Captured that year (t)', type: 'line', data: this.years.map((r) => ({ x: r.year, y: r.increment })) },
      ];
    },
    options() {
      void themeState.tick;
      const p = palette();
      const now = this.forecast.currentYear;
      return apexBase({
        colors: [p.green, p.amber],
        stroke: { width: [3, 2.5], dashArray: [0, 5] },
        fill: { type: ['gradient', 'solid'], gradient: { shadeIntensity: 1, opacityFrom: 0.5, opacityTo: 0.02, stops: [0, 100] } },
        xaxis: { type: 'numeric', tickAmount: 8, labels: { formatter: (v) => String(Math.round(v)) } },
        yaxis: [
          { title: { text: 't CO2 held' }, labels: { formatter: (v) => compact(v) } },
          { opposite: true, title: { text: 't / year' }, labels: { formatter: (v) => compact(v) } },
        ],
        annotations: {
          xaxis: [{
            x: now, borderColor: p.teal, strokeDashArray: 0, borderWidth: 2,
            label: { text: 'Today', orientation: 'horizontal', borderColor: p.teal, style: { background: p.teal, color: '#fff', fontWeight: 700 } },
          }, {
            x: now, x2: this.years.length ? this.years[this.years.length - 1].year : now, fillColor: p.green, opacity: 0.05,
          }],
        },
        legend: { position: 'top', horizontalAlign: 'right' },
        tooltip: { shared: true, intersect: false, x: { formatter: (v) => String(v) }, y: { formatter: (v) => `${fmt(v)} t` } },
      });
    }
  },
  methods: { compact }
};
</script>

<style scoped lang="scss">
@import '../widgets.scss';
</style>
